export default __webpack_public_path__ + "static/media/bit2.054d0dea.svg";